var searchPartMixin = require('../modules/mixins/searchpart.mixin');
var GeoSearchModel = require('../modules/models/geosearch.model');
var trackingUtils = require('../modules/utils/tracking.utils');
var cons = {
    ARRIVAL: 'arrival',
    DESTINATION: 'destination',
    DEPARTURE: 'departure',
    FLIGHT: 'flight',
    HOTEL: 'hotel',
    ITEM_LEVEL_MAIN: 'mainItem',
    ITEM_LEVEL_SUB: 'subItem',
    SHOW: true,
    HIDE: false,
    ALL_AIRPORTS_SUFFIX: ' - ' + Odigeo.UIElements.translations.flightsManager.allAirports,
    ERROR_KEYS: {
        SEARCH_SEGMENTS: 'searchSegments',
        DESTINATION: 'destination',
        DEPARTURE: 'departure',
        SAME_CITY: 'sameCity',
        INVALID: 'invalid',
    }, COLLECTION_ERRORS: ['sameCity', 'invalid'],
};
var segmentScheme = {
    city: '',
    country: '',
    displayName: '',
    geoNodeId: '',
    iata: '',
    name: '',
    text: '',
    type: '',
    countryCode: '',
    region: '',
    matchType: '',
    geoNodeType: '',
    itemLevel: '',
    value: '',
    numRelatedLocations: 1,
};
var segmentStrategy;

module.exports = Odigeo.Widget.extend({
    CollectionClass: Backbone.Collection.extend(searchPartMixin.extend({
        type: 'roundTrip',
        GeosearchClass: GeoSearchModel,
        segmentStrategy: null,
        ModelClass: Backbone.Model.extend({
            geosearch: {},
            product: cons.FLIGHT,
            segmentType: '',
            segmentKey: '',
            defaults: Odigeo._.omit(segmentScheme, 'value'),

            initialize: function() {
                this.on('add', this.init);
            },

            init: function() {
                this.widget = this.collection.widget;
                this.setProduct().initGeosearch();
                this.checkText();
                this.on('change', this.checkText);
                this.listenTo(this.geosearch, 'geolocated', this.setByGeoLocation);

                return this;
            },

            initGeosearch: function() {
                this.geosearch = new this.collection.GeosearchClass();
                this.geosearch.widget = this.widget;
                var maxSuggestionsCount = this.product === 'hotel' && this.segmentType === 'arrival' ?
                    this.widget.options.dynpack_max_suggestions_count : this.widget.options.flights_max_suggestions_count;
                this.geosearch.setOptions({
                    departureOrArrival: this.segmentType.toUpperCase(),
                    product: this.product.toUpperCase(),
                    max_suggestions_count: maxSuggestionsCount,
                });
                this.geosearch.init();
                this.checkGeoLocation();

                return this;
            },

            checkGeoLocation: function() {
                if (this.segmentKey === cons.DEPARTURE && !this.isValid()) {
                    this.geoLocate();
                }

                return this;
            },

            geoLocate: function() {
                this.geosearch.geolocate();

                return this;
            },

            reset: function(newValues, opts) {
                var resetConfig = {silent: true};

                opts = opts || {};
                this.clear(resetConfig).set(this.defaults, resetConfig);

                if (Odigeo._.isObject(newValues)) {
                    this.set(newValues, resetConfig);
                }

                if (!opts.silent) {
                    this.trigger('reset');
                }

                return this;
            },

            checkText: function() {
                if (Odigeo._.isEmpty(this.get('text')) && this.isValid()) {
                    this.set(this.geosearch.formatLocation(this.attributes));
                }
            },

            isValid: function() {
                return !Odigeo._.isNull(this.get('geoNodeId'));
            },

            setProduct: function() {
                if (this.segmentType === cons.ARRIVAL &&
                    this.widget.options.isArrivalHotel) {
                    this.product = cons.HOTEL;
                }

                return this;
            },

            setByGeoLocation: function(valid) {
                if (valid) {
                    this.set(this.geoSegmentFormatter(Odigeo._.first(this.geosearch.get('cities')), true));
                }
            },

            setByDestination: function(destination) {
                this.set(this.geoSegmentFormatter(destination, true));
            },

            setByGeoSearch: function(geoIndex) {
                if (this.isGeoSearchIndex(geoIndex)) {
                    this.set(this.getGeoSegmentByIndex(geoIndex));
                    if (this.segmentKey === cons.DEPARTURE) {
                        Odigeo.trigger(this.widget.id + ':goToNextTab', this.segmentKey);
                    } else {
                        Odigeo.trigger(this.widget.id + ':safeClose');
                    }
                } else {
                    this.trigger('error');
                }
                Odigeo.trigger(this.widget.id + ':refreshTabs');

                return this;
            },

            isGeoSearchIndex: function(geoIndex) {
                var geoResult = this.geosearch.filtered[geoIndex.index];

                if (Odigeo._.isUndefined(geoResult)) {
                    return false;
                }

                if (!Odigeo._.isUndefined(geoIndex.relatedIndex) &&
                    Odigeo._.isUndefined(geoResult.relatedLocations[geoIndex.relatedIndex])) {
                    return false;
                }

                return true;
            },

            getType: function() {
                return this.segmentType;
            },

            launchAutocomplete: function(val) {
                if (this.get('text') !== val.trim()) {
                    this.reset({text: val});
                }
                this.geosearch.abort();

                if (val.length >= this.widget.options.autocomplete_count) {
                    this.geosearch.filter(val.replace(cons.ALL_AIRPORTS_SUFFIX, ''));
                } else {
                    this.geosearch.clearFilter();
                }

                return this;
            },

            getGeoSegmentByIndex: function(geoIndex) {
                var isMainItem = Odigeo._.isUndefined(geoIndex.relatedIndex);
                var geoSegment = Odigeo._.clone(isMainItem ? this.geosearch.filtered[geoIndex.index] :
                    this.geosearch.filtered[geoIndex.index].relatedLocations[geoIndex.relatedIndex]);

                return this.geoSegmentFormatter(geoSegment, isMainItem, true);
            },

            geoSegmentFormatter: function(geoSegment, isMainItem, skipSuffix) {
                geoSegment.matchType = geoSegment.type;
                geoSegment.itemLevel = isMainItem ? cons.ITEM_LEVEL_MAIN : cons.ITEM_LEVEL_SUB;
                geoSegment.numRelatedLocations = Odigeo._.isObject(geoSegment.relatedLocations) ?
                    geoSegment.relatedLocations.length : 1;

                if (geoSegment.type === 'CITY' && geoSegment.numRelatedLocations > 1 && !Odigeo._.isUndefined(geoSegment.text) && !skipSuffix) {
                    geoSegment.text += cons.ALL_AIRPORTS_SUFFIX;
                }

                return Odigeo._.pick(geoSegment, Odigeo._.keys(this.defaults));
            },
        }),

        initialize: function() {
            this.setSegmentStrategy();
        },

        parse: function(attrs) {
            this.setType(this.widget.options.strategyType || attrs.type, attrs);
            return this.segmentStrategy.fetch(attrs);
        },

        pushParse: function() {
            return this.segmentStrategy.save();
        },

        clear: function(options) {
            this.remove(this.models, options);

            return this;
        },

        getErrors: function() {
            var itinerarySearchErrors = Odigeo._.filter(this.errors, Odigeo._.bind(function(error) {
                return Odigeo._.includes(Odigeo._.values(cons.ERROR_KEYS), error.key);
            }, this));

            if (this.widget.options.hasTabs && !Odigeo._.isEmpty(this.models)) {
                itinerarySearchErrors = Odigeo._.reject(itinerarySearchErrors, Odigeo._.bind(function(error) {
                    var childView = this.widget.view.getChildView(this.segmentStrategy.getModel(error));
                    var $autocompleteInput = childView.autocomplete.$container.find('.autocomplete_input');
                    return Odigeo._.isEmpty($autocompleteInput.val()) && error.type === 'invalid';
                }, this));
            }

            return itinerarySearchErrors;
        },

        setSegmentStrategy: function() {
            this.segmentStrategy = Odigeo._.reduce(segmentStrategy[this.type], function(strategy, fn, key) {
                strategy[key] = Odigeo._.bind(fn, this);

                return strategy;
            }, {}, this);

            return this;
        },

        segmentFormatter: function(departure, destination, index) {
            var searchSegment = {};
            var savedSegments = this.getOriginalData().searchSegments;
            var key = index === 0 ? cons.DEPARTURE : cons.DESTINATION;

            searchSegment.departure = !Odigeo._.isEmpty(departure) ? Odigeo._.omit(departure.attributes, 'displayName') : savedSegments[0].departure;
            searchSegment.destination = Odigeo._.omit(destination.attributes, 'displayName');
            searchSegment.dateStr = savedSegments[index].dateStr || savedSegments[index][key].dateStr;

            return searchSegment;
        },

        setType: function(type, attrs) {
            var concatType = attrs.type ? attrs.type : this.type;
            this.type = Odigeo._.isEqual(type, 'accommodation') ?
                type.concat(Odigeo.Utils.capitalize(concatType)) :
                type || this.type;
            this.setSegmentStrategy();

            return this;
        },

        getModelMetadata: function(model) {
            return {
                segmentKey: model.segmentKey,
                segmentType: model.segmentType,
                index: this.indexOf(model),
                type: this.type,
            };
        },

        createModel: function(segment) {
            var model = new this.ModelClass(segment.data);

            model.segmentType = segment.type;
            model.segmentKey = segment.key;
            this.listenTo(model, 'change reset', this.save);

            return model;
        },
    })),

    viewClass: Odigeo.CollectionView.extend({
        childViewClass: Odigeo.View.extend({
            events: {
                'keyup .autocomplete_input': 'onKeyupInput',
            },

            slctrs: {
                autocompleteContainer: '.autocomplete_results',
                errorItem: '.error_item',
                errorContainer: '.error_container',
                input: '.autocomplete_input',
                inputContainer: '.autocomplete_input_container',
            },

            initialize: function(config) {
                Odigeo._.each(config.addons, function(value, key) {
                    this[key] = value;
                }, this);

                this.autocomplete = new Odigeo.UIElements.Autocomplete(
                    this.$el,
                    this.model.geosearch, {
                        enableBlur: this.opts.enableBlur,
                        tmpl: this.autocompleteTmpl,
                        tmplZero: this.autocompleteZeroTmpl,
                        zeroMsg: this.opts.errorMsgs[this.model.segmentKey].zeroResults,
                        zeroDesc: this.opts.errorDescs && this.opts.errorDescs[this.model.segmentKey].zeroResults,
                        openContainerClass: this.slctrs.inputContainer,
                        subTree: 'relatedLocations',
                    }
                );
                this.bindEvents();

                return this;
            },

            bindEvents: function() {
                this.listenTo(this.model, 'change', this.update);
                this.listenTo(this.autocomplete, 'launch', function(val) {
                    this.model.launchAutocomplete(val);
                });
                this.listenTo(this.autocomplete, 'focus', function() {
                    this.trigger('focus');
                });
                this.listenTo(this.autocomplete, 'selected', function(geoIndex) {
                    this.hideErrors();
                    this.model.setByGeoSearch(geoIndex);
                });
                this.listenTo(this.autocomplete, 'clickCloseButton', function() {
                    trackingUtils.trackEvent('searcher_' + Odigeo.Utils.getFunnelInGlobalScope(), 'city_picker_close_autocomplete');
                });

                return this;
            },

            render: function() {
                this.$el.html(this.tmpl(Odigeo._.extend({},
                    this.model.attributes,
                    {
                        type: this.model.getType(),
                        segmentKey: this.model.segmentKey,
                    }
                )));

                return this;
            },

            update: function() {
                this.$(this.slctrs.input).val(this.model.get('text'));

                return this;
            },

            showError: function(error) {
                this.$el.addClass('invalid');
                this.$(this.slctrs.errorContainer).html(this.errorTmpl(error));

                return this;
            },

            hideErrors: function() {
                this.$el.removeClass('invalid');
                this.$(this.slctrs.errorContainer).empty();

                return this;
            },

            focus: function() {
                if (this.isEmpty() || this.hasErrors()) {
                    this.$(this.slctrs.input).focus();
                } else {
                    this.trigger('focus:error', this);
                }

                return this;
            },

            isEmpty: function() {
                return Odigeo._.isEmpty(this.$(this.slctrs.input).val());
            },

            hasErrors: function() {
                return this.$el.hasClass('invalid');
            },

            onKeyupInput: function(ev) {
                var keysIgnored = [
                    Odigeo.Events.keys.KEY_RETURN,
                    Odigeo.Events.keys.KEY_TAB,
                    Odigeo.Events.keys.KEY_DOWN,
                    Odigeo.Events.keys.KEY_UP,
                ];

                if (!Odigeo._.includes(keysIgnored, ev.keyCode)) {
                    this.hideErrors();
                    this.trigger('type');
                }
            },

            remove: function() {
                this.autocomplete.remove();
                return Odigeo.View.prototype.remove.apply(this, arguments);
            },
        }),

        events: {
            'change .autocomplete_input': 'onAutocompleteInputChange',
            'click .itinerary_done_btn': 'onItineraryDoneBtnTap',
        },

        tmpls: {
            childView: '.itinerary_selector_item_template',
            autocomplete: '.itinerary_selector_autocomplete',
            autocompleteZero: '.itinerary_autocomplete_zero_results',
            error: '.itinerary_error',
            tab: '.itinerary_tab_template',
            tabTitle: '.itinerary_tab_title_template',
        },

        init: function() {
            this.opts = Odigeo.parseOptions(this.widget.options);
            this.on('before:add:child', this.onBeforeAdd);
        },

        afterBindCollection: function() {
            this.listenTo(this.collection, 'error', this.checkErrors);

            return Odigeo.CollectionView.prototype.afterBindCollection.apply(this, arguments);
        },

        onBeforeAdd: function(childView) {
            this.listenTo(childView.model, 'change', this.onModelChange);
            this.listenTo(childView.model, 'error', this.checkErrors);
            this.listenTo(childView, 'type', this.hideErrors);
            this.listenTo(childView, 'focus:error', this.moveFocus);
        },

        checkErrors: function() {
            var errors = this.collection.getErrors();

            Odigeo._.each(errors, function(error) {
                this.showError(error);
            }, this);

            return this;
        },

        showError: function(error) {
            var child = this.getChildView(this.collection.segmentStrategy.getModel(error));

            if (child) {
                child.showError({
                    msg: this.opts.errorMsgs[error.key][error.type],
                    desc: this.opts.errorDescs && this.opts.errorDescs[error.key][error.type],
                    type: error.type,
                });
            }

            return this;
        },

        hideErrors: function() {
            var errorClasses = '.error_' + cons.COLLECTION_ERRORS.join(', .error_');

            this.each(function(child) {
                if (child.$(errorClasses).length) {
                    child.hideErrors();
                }
            });
        },

        onModelChange: function(model) {
            var child = this.getChildView(model);
            this.checkErrors();

            if (child) {
                this.moveFocus(child);
            }

            return this;
        },

        moveFocus: function(current) {
            var nextChild = this.getNextChildView(current);

            if (current.model.segmentKey === cons.DEPARTURE && !current.hasErrors() && nextChild) {
                nextChild.focus();
            } else if (current.model.segmentKey === cons.DESTINATION && !current.hasErrors()) {
                Odigeo.trigger(
                    this.widget.id + ':completed',
                    this.collection.getModelMetadata(current.model)
                );
            }
        },

        onItineraryDoneBtnTap: function() {
            Odigeo.trigger(this.widget.id + ':safeClose');
        },

        initTabs: function() {
            if (!this.tabHandler) {
                var $tabs = this.$el.find('.itinerarysearch_tabs');
                var tabTemplate = Odigeo._.template(this.$el.find(this.tmpls.tab).html(), {variable: 'model'});

                $tabs.html(Odigeo._.map(this.collection.models, function(model) {
                    return tabTemplate(model);
                }).join('\n'));

                this.tabHandler = Odigeo.UIElements.enhanceTabs($tabs, {
                    panelSelector: '.panel_container_itinerary_searchmanager',
                    defaultTab: cons.DEPARTURE,
                });

                this.refreshTabTitles();

                $tabs.on('change', Odigeo._.bind(function(event) {
                    var dataIndex = event.target.dataset.index;
                    var tabName = dataIndex === '0' ? cons.DEPARTURE : cons.DESTINATION;
                    this.moveTabBackground(tabName);
                    this.focusAutocompleteInputInTab(tabName);
                }, this));
            }
            return this;
        },

        refreshTabTitles: function(models) {
            models = models || this.collection.models;

            if (this.tabHandler) {
                var tabTitleTemplate = Odigeo._.template(this.$el.find(this.tmpls.tabTitle).html(), {variable: 'params'});
                Odigeo._.each(models, Odigeo._.bind(function(model) {
                    var $tab = this.$el.find('.itinerarysearch_tab[data-panel=' + model.segmentKey + ']');
                    var params = {
                        title: this.getTabTitle(model),
                        subtitle: this.getTabSubtitle(model),
                    };
                    $tab.html(tabTitleTemplate(params));
                }, this));
            }

            return this;
        },

        getTabTitle: function(model) {
            var tabParams = this.widget.options.tab;
            var defaultTitle = model.segmentKey === cons.DEPARTURE ? tabParams.departure.title : tabParams.destination.title;
            var iata = model.get('iata') || model.get('displayName') || model.get('name');
            return Odigeo._.isEmpty(iata) ? defaultTitle : iata;
        },

        getTabSubtitle: function(model) {
            var tabParams = this.widget.options.tab;
            var defaultSubtitle = model.segmentKey === cons.DEPARTURE ? tabParams.departure.subtitle : tabParams.destination.subtitle;
            var city = model.get('displayName') || model.get('name');
            return Odigeo._.isEmpty(city) ? defaultSubtitle : city;
        },

        moveTabBackground: function(tab) {
            var $tabBackground = this.$el.find('.itinerarysearch_tab_highlight_box');
            var addOrRemoveMovedClass = tab === cons.DEPARTURE ? 'remove' : 'add';
            $tabBackground[addOrRemoveMovedClass + 'Class']('moved');
            return this;
        },

        onAutocompleteInputChange: function(event) {
            var model = this.collection.models[$(event.target).data('segment') === cons.DEPARTURE ? 0 : 1];
            this.refreshTabTitles([model]);
        },

        focusAutocompleteInputInTab: function(tab) {
            this.$el.find('.panel_' + tab + ' .autocomplete_input').focus();
            return this;
        },

        childViewOptions: function(model) {
            return Odigeo._.extend(Odigeo.CollectionView.prototype.childViewOptions.apply(this, arguments), {
                className: this.opts.childViewClass + ' ' + model.segmentKey,
                addons: {
                    opts: this.opts,
                    tmpl: Odigeo._.template(
                        this.$(this.tmpls.childView).html(),
                        {variable: 'segment'}
                    ),
                    autocompleteTmpl: Odigeo._.template(
                        this.$(this.tmpls.autocomplete).html(),
                        {variable: 'autocomplete'}
                    ),
                    errorTmpl: Odigeo._.template(
                        this.$(this.tmpls.error).html(),
                        {variable: 'error'}
                    ),
                    autocompleteZeroTmpl: Odigeo._.template(
                        this.$(this.tmpls.autocompleteZero).html(),
                        {variable: 'tmpl'}
                    ),
                },
            });
        },
    }),

    init: function() {
        this.options = Odigeo.parseOptions(this.options);
        this.collection = new this.CollectionClass();
        this.collection.widget = this;
        this.collection.init();
        this.view.collection = this.collection;
        this.view.afterBindCollection();

        return this;
    },

    refreshTabs: function() {
        this.view.refreshTabTitles();
    },

    switchTab: function(tab) {
        this.view.initTabs();
        this.view.tabHandler.hideActivePanel();
        this.view.tabHandler.setActiveTab(tab);
        this.view.tabHandler.togglePanelWithName(tab);
        this.view.moveTabBackground(tab);
        Odigeo._.defer(Odigeo._.bind(this.view.focusAutocompleteInputInTab, this.view, tab));
        return this;
    },

    goToNextTab: function(activeTab) {
        this.switchTab(activeTab === cons.DEPARTURE ? cons.DESTINATION : cons.DEPARTURE);
    },

    safeClose: function() {
        var searchError = Odigeo._.first(this.collection.getErrors());

        if (searchError) {
            this.switchTab(searchError.key);
            this.view.showError(searchError);
        } else {
            Odigeo.trigger(this.id + ':close');
        }

        return this;
    },

    forceAccommodationInputValue: function(actualSearchCity) {
        this.view.$('.pba_input').val(actualSearchCity);
        return this;
    },
    setByDestination: function(destination) {
        const model = this.collection.segmentStrategy.getModel({key: cons.DESTINATION});
        if (model && destination) model.setByDestination(destination);
    },
});

segmentStrategy = {
    roundTrip: {
        fetch: function(attrs) {
            return Odigeo._.reduce(attrs.searchSegments, function(models, segment, index) {
                var segmentModel = {};

                if (index === 0) {
                    segmentModel.type = cons.DEPARTURE;
                    segmentModel.key = cons.DEPARTURE;
                } else {
                    segmentModel.type = cons.ARRIVAL;
                    segmentModel.key = cons.DESTINATION;
                }

                segmentModel.data = segment.departure;
                models.push(this.createModel(segmentModel));

                return models;
            }, [], this);
        },

        save: function() {
            var saved = {searchSegments: []};

            saved.searchSegments.push(this.segmentFormatter(this.models[0], this.models[1], 0));
            saved.searchSegments.push(this.segmentFormatter(this.models[1], this.models[0], 1));
            saved.searchSegments.type = this.type;

            return saved;
        },

        getModel: function(metadata) {
            switch (metadata.key) {
                case cons.DEPARTURE:
                    return this.models[0];
                case cons.DESTINATION:
                    return this.models[1];
                default:
                    return false;
            }
        },
    },

    oneWayTrip: {
        fetch: function() {
        },

        save: function() {
        },

        getModel: function() {
        },
    },

    multipleTrip: {
        fetch: function() {
        },

        save: function() {
        },

        getModel: function() {
        },
    },

    accommodationRoundTrip: {
        fetch: function(attrs) {
            return Odigeo._.reduce(attrs.searchSegments, function(models, segment, index) {
                var segmentModel = {};

                if (index === 0) {
                    segmentModel.type = cons.DEPARTURE;
                    segmentModel.key = cons.DEPARTURE;
                    segmentModel.data = segment.departure;
                } else {
                    segmentModel.type = cons.ARRIVAL;
                    segmentModel.key = cons.DESTINATION;
                    segmentModel.data = attrs.accommodationDestination;
                }

                models.push(this.createModel(segmentModel));

                return models;
            }, [], this);
        },

        save: function() {
            var saved = {searchSegments: []};

            saved.searchSegments.push(this.segmentFormatter(this.models[0], this.models[1], 0));
            saved.searchSegments.push(this.segmentFormatter(this.models[1], this.models[0], 1));
            saved.searchSegments.type = this.type;
            saved.accommodationDestination = Odigeo._.omit(this.models[1].toJSON(), 'displayName');

            return saved;
        },

        getModel: function(metadata) {
            switch (metadata.key) {
                case cons.DEPARTURE:
                    return this.models[0];
                case cons.DESTINATION:
                    return this.models[1];
                default:
                    return false;
            }
        },
    },
    accommodationOneWayTrip: {
        fetch: function(attrs) {
            return Odigeo._.reduce(attrs.searchSegments, function(models) {
                var segmentModel = {
                    type: cons.ARRIVAL,
                    key: cons.DESTINATION,
                    data: attrs.accommodationDestination,
                };

                models.push(this.createModel(segmentModel));

                return models;
            }, [], this);
        },

        save: function() {
            var saved = {searchSegments: []};

            saved.searchSegments.type = this.type;
            saved.accommodationDestination = Odigeo._.omit(this.models[0].toJSON(), 'displayName');
            saved.searchSegments.push(this.segmentFormatter(null, this.models[0], 0));

            return saved;
        },

        getModel: function(metadata) {
            switch (metadata.key) {
                case cons.DESTINATION:
                    return this.models[0];
                default:
                    return false;
            }
        },
    },
};
